
enum SortDirection {
  Unknown = 0,
  None = 1,
  Descending = 2,
  Ascending = 3,
}

export { SortDirection };
